const formatScaled = (scaled, unit) => {
  const decimals = Math.abs(scaled) < 10 ? 1 : 0;
  return `${parseFloat(scaled.toFixed(decimals))}${unit}`;
};

const abbreviateNumber = value => {
  const number = Math.round(value);
  if (!Number.isFinite(number)) return '0';
  const abs = Math.abs(number);
  if (abs < 1000) return String(number);
  if (Math.round(abs / 1000) < 1000) return formatScaled(number / 1000, 'k');
  return formatScaled(number / 1000000, 'M');
};

export default abbreviateNumber;
